import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "total-stations" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_indicator = _resolveComponent("widget-indicator")!

  return (_openBlock(), _createBlock(_component_widget_indicator, {
    title: _ctx.$t('dashboard.ok_indicator.title'),
    class: "widget-indicator-ok",
    description: _ctx.$t('dashboard.ok_indicator.description'),
    value: _ctx.count,
    variation: _ctx.variation,
    variationColor: _ctx.color,
    colorClass: "has-text-success"
  }, {
    subvalue: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('widget_indicator_ok.n_station_out_of', { total : _ctx.stations?.length})), 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "description", "value", "variation", "variationColor"]))
}